import React from 'react';
import { FaWpforms, FaChalkboardTeacher, FaTable, FaCertificate } from 'react-icons/fa'; // Import only the required icons
import './IconComponent.css';
export default function IconComponent({ iconName }) {
    const Icon = getIconByName(iconName); // Get the icon based on the name
  
    return (
      <div className="iconComponent">
        {Icon ? <Icon  /> : <p>Icon not found</p>} {/* Render the icon or fallback */}
      </div>
    );
  }
  // Define a function that returns the correct icon based on the name
  const getIconByName = (iconName) => {
    const iconMap = {
      Frameworks: FaWpforms,
      Courses: FaChalkboardTeacher,
      Programs: FaTable,
      Certificates:FaCertificate
    };
  
    return iconMap[iconName] || null; // Return the icon component or null if not found
  };
  